export default __webpack_public_path__ + "static/media/add-resource-enabled.c3f257a8.svg";